<template>
	<div class="box" id="ticket-config">
		<div class="box__container">
			<div class="box__header">
				<div class="box__header__title">
					<h2>{{ 'tickets' | translate | capitalize }}</h2>
				</div>
			</div>
			<div class="box__body">
				<div class="box__body__subtitle">
					<p>{{ 'ticketsConfigDescription' | translate | capitalize }}</p>
				</div>
				<template v-if="ticketTypes">
					<table class="table-navigation" v-if="editing === null">
						<thead>
							<tr>
								<th>{{ 'ticket' | translate | titleCase }}</th>
								<th>{{ 'ticket-response-time' | translate | titleCase }}</th>
								<th>{{ 'responsible' | translate | titleCase }}</th>
								<th>{{ 'edit' | translate | titleCase }}</th>
							</tr>
						</thead>

						<tbody>
							<tr
								v-for="(ticketType, index) in ticketTypes.ticket_types"
								:key="ticketType.id"
							>
								<td :title="'ticket' | translate">
									{{ ticketType.name }}
								</td>
								<td :title="'ticket-response-time' | translate">
										{{ 'upTo' | translate }}
									<template v-if="ticketType.usual_response_interval">
										{{ ticketType.usual_response_interval.split(' ')[0] }}
										{{ ticketType.usual_response_interval.split(' ')[1] | translate | lowercase }}
									</template>
								</td>
								<td :title="'responsible' | translate">
									{{ ticketType.send_email_to }}
								</td>
								<td :title="'solicitation' | translate">
									<button @click="setEdition(ticketType.id)">{{ 'edit' | translate }}</button>
								</td>
							</tr>
						</tbody>
					</table>

					<div
						v-for="(ticketType, index) in ticketTypes.ticket_types"
						:key="ticketType.id"
					>
					<form @submit.prevent="submitTicketConfig" class="edit" v-if="editing === ticketType.id">
						<input type="hidden" :value="ticketType.id" name="ticket_id">
						<div class="form__wrap form__wrap__group">
							<div class="form__wrap__group">
								<div class="label-wrap">
									<label>
										{{ 'ticket' | translate }}
									</label>
								</div>
								<input type="text" :value="ticketType.name" readonly>
							</div>
							<div class="form__wrap__group">
								<div class="label-wrap">
									<label>
										{{ 'ticket-response-time' | translate }}
										({{ 'inDays' | translate | lowercase }})
									</label>
								</div>
								<input
									type="number"
								  min="0"
									onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57"
									name="usual_response_interval"
									:value=" ticketType.usual_response_interval
									 ? ticketType.usual_response_interval.split(' ')[0]
									 : ''"
								>
							</div>
						</div>

						<div class="form__wrap form__wrap__group">
							<div class="form__wrap__group">
								<div class="label-wrap">
									<label>
										{{ 'responsibleDescription' | translate }}
									</label>
								</div>
								<input type="email" name="send_email_to" :value="ticketType.send_email_to">
							</div>
						</div>

						<div class="form__wrap__group edit-submit-buttons">
							<button @click="editing = null">{{ 'cancel' | translate }}</button>
							<button
								type="submit"
								:aria-busy="submitLoading ? 'true' : 'false'"
								:class="submitLoading ? 'button--loading' : ''"
								:disabled="submitLoading"
							>
							<template v-if="submitLoading">
								<img src="/assets/images/loading-white.svg" alt="loading">
							</template>
							<template v-else>
								{{ 'save' | translate }}
							</template>
							</button>
						</div>
					</form>
				</div>

				</template>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment';

// Validator.localize('ptBr', ptBr);
moment.locale('pt-BR');

export default {
	name: 'ticketsConfig',
	data() {
		return {
			session: {
				apiKey: sessionStorage.getItem('apiKey'),
				userId: sessionStorage.getItem('userId'),
			},
			successMsg: false,
			submitLoading: false,
			editing: null,
		};
	},
	mounted() {
		this.$store.dispatch('getTicketTypes', this.session);
	},
	computed: {
		error() {
			return this.$store.state.error;
		},
		user() {
			return this.$store.state.user;
		},
		success() {
			return this.$store.state.status;
		},
		ticketTypes() {
			return this.$store.state.profile.ticketTypes;
		},
	},
	methods: {
		toggleSubmitLoading() {
			this.submitLoading = !this.submitLoading;
		},
		setEdition(id) {
			document.querySelector('#ticket-config').scrollIntoView();
			this.editing = id;
		},
		errorForm(obj, field) {
			let erro = false;
			if (obj) {
				if (obj[field]) {
					erro = true;
				}
			}
			return erro;
		},
		formatTime(time) {
			return `${time} days`;
		},
		submitTicketConfig(event) {
			const payload = {};
			payload.ticket_type_id = event.target.elements.ticket_id.value;

			payload.send_email_to = event.target.elements.send_email_to.value
				? event.target.elements.send_email_to.value
				: '__DELETE__';

			if (event.target.elements.usual_response_interval.value) {
				payload.usual_response_interval = this.formatTime(event.target.elements.usual_response_interval.value);
			} else {
				payload.usual_response_interval = '__DELETE__';
			}

			this.toggleSubmitLoading();
			this.$store.dispatch('postTicketConfig', payload)
				.then(() => {
					this.validate();
					this.editing = null;
					this.toggleSubmitLoading();
				})
				.then(() => {
					this.$store.dispatch('getTicketTypes', this.session);
				})
				.catch(() => {
					this.toggleSubmitLoading();
				});
		},
		validate() {
			if (this.success) {
				this.successMsg = this.success;
				setTimeout(() => {
					this.successMsg = false;
				}, 5000);
			}
		},
	},
};
</script>
<style>
	.edit {
		display: block;
	}

	.edit .days-placeholder {
		flex-grow: 0;
		margin-top: 3.5rem;
	}

	.edit .edit-submit-buttons {
		margin-top: 1.5rem;
		text-align: right;
	}

	.edit .edit-submit-buttons button {
		margin-bottom: 1rem;
	}

	.form__wrap__group--single {
		margin-top: 56px;
	}

	.form__wrap__group--single select {
		height: 50px
	}
</style>




// WEBPACK FOOTER //
// _source/javascripts/modules/profile/ticketsConfig.vue